import { Link } from 'react-router-dom';
import './CTA.css';

function CTA() {
  return (
    <section className="cta">
      <h2 className="cta-title">Ready to Create Your First Event?</h2>
      <p className="cta-subtitle">Join thousands of users who trust AttendX for their celebrations</p>
      <Link to="/signup" className="cta-btn">Get Started - It's Easy  &rarr;</Link>
    </section>
  );
}

export default CTA;
